import React, { useState } from "react";
import classes from './Collapse.module.css';


const Collapse = ({ title, content }) => {

    const [showContent, setShowContent] = useState(false)

    const handleCollapse = e => {
        e.stopPropagation();
        setShowContent(showContent => !showContent)
    }

    return (
        <div className={classes.CollapseContainer}>
            <button className={classes.ButtonContainer} onClick={handleCollapse}>
                <div className={`${classes.Circle} ${showContent ? classes.MinusCircle : classes.PlusCircle}`}>
                    <div className={classes.Minus}></div>
                    {!showContent && <div className={classes.Plus}></div>}
                </div>
                <p className={classes.Title}>{title}</p>
            </button>
            {showContent && <p className={classes.Content}>{content}</p>}
        </div>
    )
}
export default Collapse;